import { Navigate, useLocation } from "react-router-dom";
import { useAdminAuth } from "@/lib/AdminAuthContext";

export default function ProtectedRoute({ children }) {
  const { admin, loading } = useAdminAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen bg-[#1a2421] text-[#f9f6f0]/50 grid place-items-center text-sm">
        Cargando…
      </div>
    );
  }
  if (!admin) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }
  return children;
}
